import { Card, createFullDeck, shuffleArray } from '../utils/CardUtils';

export interface DealResult {
  hands: [Card[], Card[]]; // two player hands
  pozzetti: [Card[], Card[]]; // two pozzetti
  drawPile: Card[];
  discardPile: Card[];
}

export function dealCards(): DealResult {
  const deck = shuffleArray(createFullDeck());
  let index = 0;

  // Deal 11 cards to each player
  const hand1: Card[] = [];
  const hand2: Card[] = [];
  for (let i = 0; i < 11; i++) {
    hand1.push(deck[index++]);
    hand2.push(deck[index++]);
  }

  // Create two pozzetti of 11 cards each
  const pozzetto1: Card[] = deck.slice(index, index + 11);
  index += 11;
  const pozzetto2: Card[] = deck.slice(index, index + 11);
  index += 11;

  // First card of remaining goes to discard pile
  const discardPile: Card[] = [deck[index++]];

  // Rest is draw pile
  const drawPile: Card[] = deck.slice(index);

  return {
    hands: [hand1, hand2],
    pozzetti: [pozzetto1, pozzetto2],
    drawPile,
    discardPile,
  };
}
